import { render, staticRenderFns } from "./PriceDeviationDashboard.vue?vue&type=template&id=535b7c88&scoped=true&"
import script from "./PriceDeviationDashboard.vue?vue&type=script&lang=js&"
export * from "./PriceDeviationDashboard.vue?vue&type=script&lang=js&"
import style0 from "./PriceDeviationDashboard.vue?vue&type=style&index=0&id=535b7c88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535b7c88",
  null
  
)

export default component.exports